/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Google_Auth_TitleInputs */

const en_admin_settings_groups_google_auth_title = /** @type {(inputs: Admin_Settings_Groups_Google_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Auth`)
};

/**
* | output |
* | --- |
* | "Google Auth" |
*
* @param {Admin_Settings_Groups_Google_Auth_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_google_auth_title = /** @type {((inputs?: Admin_Settings_Groups_Google_Auth_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Google_Auth_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_google_auth_title(inputs)
});
export { admin_settings_groups_google_auth_title as "admin.settings.groups.google_auth.title" }